import { Box } from '@mui/material';
import { LayoutType } from 'model/deals.model';
import TeamColumnGrid from './TeamColumnGrid';
import TeamRowGrid from './TeamRowGrid';
type TeamData = {
  members: [
    {
      id: string | null;
      position: string | null;
      name: string | null;
      mobile: string | null;
      phone: string | null;
      address: {
        city: string | null;
        country: string | null;
        geocodeAccuracy: string | null;
        latitude: string | null;
        longitude: string | null;
        postalCode: string | null;
        state: string | null;
        street: string | null;
      };
      company: string | null;
      email: string | null;
      openDeals: string | null;
      openTasks: string | null;
      title: string | null;
      profile_image_url: string | null;
    },
  ];
};
type TeamListProps = {
  layout: LayoutType;
  category: string;
  data: TeamData;
  loading: boolean;
};

const TeamsList = ({ layout, category, data, loading }: TeamListProps) => {
  const Content = layout === LayoutType.KANBAN ? TeamColumnGrid : TeamRowGrid;

  return (
    <Box>
      <Content teams={data} category={category} loading={loading} />
    </Box>
  );
};

export default TeamsList;
